module.exports = __webpack_public_path__ + "static/media/MentorBorkaBuseska.04f31972.jpg";